class WebRTCConfig {
  constructor(){        
     this.stun_turn_servers = {
      'iceServers': [
        {
          'urls': [
            'stun:35.157.87.227:3478',
          //   "stun:52.28.103.128:34781",
            ]
        },
        {
          'urls': [
              // 'turn:35.157.87.227:3478',  
              'turn:35.157.87.227:3478?transport=tcp',
              'turn:35.157.87.227:3478?transport=udp'              
          ],              
          'username': 'test',
          'credential':'webrtc'
        },       
      ],
      // 'iceTransportPolicy':"relay",
      // 'iceCandidatePoolSize': 10
    }

    this.SOCKET_CALL_TIMEOUT = "SOCKET_CALL_TIMEOUT"
    this.SOCKET_DECLINE_CALL = "SOCKET_DECLINE_CALL"
    this.SOCKET_CREATE_RTC_CALL = "SOCKET_CREATE_RTC_CALL"
    this.SOCKET_UPGRADE_ANSWER_FROM_CALLER = "SOCKET_UPGRADE_ANSWER_FROM_CALLER"
    this.SOCKET_UPGRADE_CALL_FROM_CALLEE = "SOCKET_UPGRADE_CALL_FROM_CALLEE"
    this.SOCKET_UPGRADE_CALL = "SOCKET_UPGRADE_CALL"
    this.SOCKET_OFFER_ICE = "SOCKET_OFFER_ICE"
    this.SOCKET_ANSWER_ICE = "SOCKET_ANSWER_ICE"
    this.SOCKET_REC_USER_CALL = "SOCKET_REC_USER_CALL"
    this.SOCKET_CREATED_ANSWER = "SOCKET_CREATED_ANSWER"
    this.SOCKET_UPGRADE_CREATED_ANSWER = "SOCKET_UPGRADE_CREATED_ANSWER"
    this.SOCKET_CREATE_JOIN_RTC_CALL = "SOCKET_CREATE_JOIN_RTC_CALL"

  }       
}

export default new WebRTCConfig()

            